import api from "./axios";

export const getBranchUserRoles = async (branchId) => {
    const res = await api.get(`/branch-user-roles/${branchId}`);
    return Array.isArray(res.data) ? res.data : [];
};

export const assignUserRole = async (userId, roleId) => {
    const res = await api.post("/user-role", {
        user_id: userId,
        role_id: roleId,
    });

    return res.data?.data || null;
};

// CREATE
export const createBranchUserRole = async (payload) => {
    const res = await api.post("/branch-user-roles", payload);
    return res.data;
};

// UPDATE
export const updateBranchUserRole = async (id, payload) => {
    const res = await api.put(`/branch-user-roles/${id}`, payload);
    return res.data;
};

// DELETE
export const deleteBranchUserRole = async (id) => {
    await api.delete(`/branch-user-roles/${id}`);
};
export const getBranchUsersByRoleAndDate = async ({
                                                      branchId,
                                                      roleId,
                                                      date1,
                                                      date2
                                                  }) => {
    let url = `/branch_user_list/${branchId}?role_id=${roleId}`;

    if (date1) url += `&date1=${date1}`;
    if (date2) url += `&date2=${date2}`;

    const res = await api.get(url);

    return res.data?.branch_users || [];
};
